import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  RequestOfferRequestRefundErrorResponse,
  RequestOfferRequestRefundRequest,
  RequestOfferRequestRefundSuccessResponse
} from './requestOfferRequestRefund.types'

export const requestOfferRequestRefundApi = async (
  request: RequestOfferRequestRefundRequest
): Promise<RequestOfferRequestRefundSuccessResponse> => {
  const response = await configureRequest({
    url: urls.payments.requestOfferRequestRefund,
    method: 'POST',
    data: request,
    params: {},
    headers: {
      'X-User-Role': UserRole.shopper
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as RequestOfferRequestRefundSuccessResponse
  } else {
    throw response as RequestOfferRequestRefundErrorResponse
  }
}

export default requestOfferRequestRefundApi
